import React, { useRef, ChangeEvent } from 'react';
import { Props as MaskProps } from 'react-input-mask';

import { Container, InputContainer, StyledInput, Error, ValidIcon, PrefixSuffix } from './styles';

export interface Props extends Partial<MaskProps> {
  id?: string;
  type?: string;
  value?: string;
  prefix?: string;
  suffix?: string;
  touched?: boolean;
  placeholder?: string;
  disabled?: boolean;
  children?: JSX.Element;
  error?: string;
  inputmode?: string;
  isValid?: boolean;
  rightCheckIfIsValid?: boolean;
  className?: string;
  darkPlaceholder?: boolean;
  replaceFontSizePlaceholder?: boolean;
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Input = ({
  value,
  prefix,
  suffix,
  mask,
  maskChar,
  error,
  children,
  isValid,
  rightCheckIfIsValid,
  className,
  onBlur,
  darkPlaceholder,
  replaceFontSizePlaceholder,
  ...props
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const hasValidIcon = isValid && !children && rightCheckIfIsValid && value !== '';

  const scrollToInput = () => {
    setTimeout(
      () =>
        ref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        }),
      500,
    );
  };

  const handleFocus = () => {
    scrollToInput();
  };

  const handleBlur = (event: ChangeEvent<HTMLInputElement>) => {
    if (onBlur) onBlur(event);
  };

  return (
    <div ref={ref}>
      <Container className={className || ''} styledProps={{ hasError: !!error }}>
        {prefix && <PrefixSuffix>{prefix}</PrefixSuffix>}
        <InputContainer>
          <StyledInput
            $replaceFontSizePlaceholder={replaceFontSizePlaceholder}
            $hasValidIcon={hasValidIcon}
            onFocus={handleFocus}
            mask={mask || ''}
            maskChar=""
            value={value}
            onBlur={handleBlur}
            $darkPlaceholder={darkPlaceholder}
            {...props}
          />
          {children}
          {hasValidIcon && <ValidIcon />}
        </InputContainer>
        {suffix && <PrefixSuffix>{suffix}</PrefixSuffix>}
      </Container>
      {error && <Error>{error}</Error>}
    </div>
  );
};

export default Input;
